// extracted by mini-css-extract-plugin
export default {"wrapper":"uT-z","availablePromoMessagesLabel":"vT-z","promoMessageList":"wT-z","promoMessage":"xT-z","appliedPromoMessage":"yT-z","promoMessageAmount":"zT-z"};